module.exports = __webpack_public_path__ + "static/media/logo.1b3ebe44.svg";